import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BASE_URL from "api/Api";
import "assets/theme/admin_list.css";
import { FaBuilding, FaPlus, FaEdit, FaTrash, FaCheck, FaTimes } from "react-icons/fa";

const WardList = () => {
  const [wards, setWards] = useState([]);
  const [editId, setEditId] = useState(null);
  const [editData, setEditData] = useState({
    ward_number: "",
    ward_name: "",
  });

  // Fetch wards
  useEffect(() => {
    fetch(`${BASE_URL}super_admin/list_ward`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
      },
    })
      .then((res) => res.json())
      .then((data) => setWards(data.wards || data))
      .catch((err) => console.error(err));
  }, []);

  // Start edit
  const handleEdit = (ward) => {
    setEditId(ward.ward_id);
    setEditData({
      ward_number: ward.ward_number,
      ward_name: ward.ward_name || "",
    });
  };

  // Cancel edit
  const handleCancel = () => {
    setEditId(null);
    setEditData({ ward_number: "", ward_name: "" });
  };

  // Save edit
  const handleSave = async (id) => {
    if (!editData.ward_number) {
      alert("Ward number is required");
      return;
    }

    try {
      const res = await fetch(
        `${BASE_URL}super_admin/edit_ward/${id}`,
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify(editData),
        }
      );

      const data = await res.json();
      if (!res.ok) throw new Error(data.message);

      setWards((prev) =>
        prev.map((w) =>
          w.ward_id === id ? { ...w, ...editData } : w
        )
      );

      handleCancel();
    } catch (error) {
      alert(error.message);
    }
  };

  // Delete ward
  const handleDelete = async (id) => {
    if (!window.confirm("Are you sure you want to delete this ward?")) return;

    try {
      const res = await fetch(
        `${BASE_URL}super_admin/delete_ward/${id}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
        }
      );

      if (!res.ok) throw new Error("Failed to delete ward");

      setWards((prev) => prev.filter((w) => w.ward_id !== id));
    } catch (error) {
      alert(error.message);
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />

      <div className="admin-page-container">
        {/* Header */}
        <div className="admin-header-card d-flex align-items-center justify-content-between flex-wrap gap-3">
          <div className="d-flex align-items-center">
            <div className="admin-header-icon">
              <FaBuilding />
            </div>
            <div>
              <h4 className="admin-header-title">प्रभाग / वॉर्ड व्यवस्थापन (Ward Management)</h4>
              <p className="admin-header-subtitle mb-0">
                शहरांमधील प्रभाग (Ward) क्रमांक आणि प्रभाग नावे व्यवस्थापित करा
              </p>
            </div>
          </div>

          <Link to="/ward" className="btn-admin-add">
            <FaPlus /> नवीन प्रभाग जोडा
          </Link>
        </div>

        {/* Table Card */}
        <div className="admin-table-card">
          {wards.length === 0 ? (
            <div className="text-center py-5 text-muted">
              कोणताही प्रभाग आढळला नाही.
            </div>
          ) : (
            <div className="table-responsive">
              <table className="table table-admin-custom">
                <thead>
                  <tr>
                    <th>Sr. No.</th>
                    <th>जिल्हा (District)</th>
                    <th>उपविभाग (Subdistrict)</th>
                    <th>शहर (City)</th>
                    <th>प्रभाग क्र. (Ward No)</th>
                    <th>प्रभाग नाव (Ward Name)</th>
                    <th className="text-end">कृती (Actions)</th>
                  </tr>
                </thead>

                <tbody>
                  {wards.map((ward, index) => (
                    <tr key={ward.ward_id}>
                      <td className="fw-bold text-secondary">{index + 1}</td>

                      <td className="fw-bold text-dark">{ward.district_name}</td>

                      <td className="text-secondary">{ward.subdistrict_name}</td>

                      <td>
                        <span className="badge bg-light text-dark border">
                          {ward.city_name}
                        </span>
                      </td>

                      {/* Ward Number */}
                      <td>
                        {editId === ward.ward_id ? (
                          <input
                            type="text"
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editData.ward_number}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                ward_number: e.target.value,
                              })
                            }
                          />
                        ) : (
                          <span className="badge-status badge-status-info">
                            Ward #{ward.ward_number}
                          </span>
                        )}
                      </td>

                      {/* Ward Name */}
                      <td>
                        {editId === ward.ward_id ? (
                          <input
                            type="text"
                            className="form-control form-control-sm admin-select py-1 px-2"
                            value={editData.ward_name}
                            onChange={(e) =>
                              setEditData({
                                ...editData,
                                ward_name: e.target.value,
                              })
                            }
                          />
                        ) : (
                          <span className="fw-semibold text-dark">{ward.ward_name || "—"}</span>
                        )}
                      </td>

                      {/* Actions */}
                      <td className="text-end">
                        {editId === ward.ward_id ? (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-view"
                              onClick={() => handleSave(ward.ward_id)}
                              title="जतन करा"
                            >
                              <FaCheck />
                            </button>

                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={handleCancel}
                              title="रद्द करा"
                            >
                              <FaTimes />
                            </button>
                          </div>
                        ) : (
                          <div className="admin-action-group justify-content-end">
                            <button
                              className="btn-action-icon btn-action-edit"
                              onClick={() => handleEdit(ward)}
                              title="संपादित करा"
                            >
                              <FaEdit />
                            </button>

                            <button
                              className="btn-action-icon btn-action-delete"
                              onClick={() => handleDelete(ward.ward_id)}
                              title="हटवा"
                            >
                              <FaTrash />
                            </button>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </div>
    </DashboardLayout>
  );
};

export default WardList;
